var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"text":"Dropdown Button"}},[_vm._l((_vm.options),function(option){return [_c('b-dropdown-item',{key:option.id,attrs:{"value":option.id},on:{"click":function($event){_vm.selected = option.id}}},[_vm._t("item",null,{"option":option})],2)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }